import RemoteResourceRepository from './RemoteResourceRepository'

/*
 * RemoteReferenceRepository is a simple implementation of the RemoteRepository
*/
export default class RemoteReferenceRepository extends RemoteResourceRepository {
  constructor () {
    super('reference')
  }

  createOrGetRecord ({data}) {
    return this.createRecord({data})
  }
}
